// data/languages/yoruba/illustrations.ts
// Les clés reprennent celles de categories/index.ts.

export const categoryIllustrations = {
  'Alphabet yoruba': 'Ẹ',
  'Salutations et expressions courantes': '👋',
  'Nombres': '🔢',
  'Temps': '📅',
  'Animaux': '🐢',
  'Famille': '👨‍👩‍👧‍👦',
  'Nourriture': '🍲',
  'Couleurs': '🎨',
  'Corps': '🧑',
  'Verbes': '🏃‍♂️',
  'Objets du quotidien': '🥁',
  'Grammaire': '📚'
};

export default categoryIllustrations;
